<!-- TEMPLATE -->
<template>
  <div>
    <input-table :serviceType="serviceType" :data="services" :payloadData="payloadData"></input-table>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ToolsMixin from '@/mixins/toolsMixin';
import {BTable} from 'bootstrap-vue';
import {
  deanIcon,
  plusIcon,
  deanButton,
  trashIcon,
  deanFormRow,
  deanSectionTitle,
  deanSectionDivider,
  deanSectionTitleItem,
  deanLoadOverlay,
} from '@deanone/dean-components';
import DeanInputField from '@/components/deanComponents/deanInputField.vue';
import DeanInputSwitch from '@/components/deanComponents/deanInputSwitch.vue';
import InputTable from '@/components/quote/inputTable.vue';
import {ServiceTypeEnum} from "@/enums/ServiceTypeEnum";

@Component({
  components: {
    deanIcon,
    plusIcon,
    deanButton,
    trashIcon,
    deanFormRow,
    deanSectionTitle,
    deanSectionDivider,
    deanSectionTitleItem,
    deanLoadOverlay,
    BTable,
    DeanInputField,
    DeanInputSwitch,
    InputTable,
  },
   mixins: [
    ToolsMixin,
   ],
})

export default class FinalizingForm extends Vue {
  @Prop({}) public serviceType!: ServiceTypeEnum|null;
  @Prop({}) public services!: any;
  @Prop({}) public payloadData!: any;
}

</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

</style>
